import React, { FC } from "react";
import { styled } from "@material-ui/styles";

import KPICard from "../../elements/KPICard";

type AdvertisersMetricsProps = {
  totalAdvertisers: number;
  activeCampaigns: number;
  totalSpendMtd: string;
  avgCtr: string;
};

const Root = styled("div")({
  display: "flex",
  gap: 16,
  flexWrap: "wrap",
  marginBottom: 24,
});

const AdvertisersMetrics: FC<AdvertisersMetricsProps> = ({
  totalAdvertisers,
  activeCampaigns,
  totalSpendMtd,
  avgCtr,
}) => (
  <Root>
    <KPICard label="Total Advertisers" value={totalAdvertisers} />
    <KPICard label="Active Campaigns" value={activeCampaigns} />
    <KPICard label="Total Spend (MTD)" value={totalSpendMtd} />
    <KPICard label="Avg. CTR" value={avgCtr} />
  </Root>
);

export default AdvertisersMetrics;
